module.exports = {"410328100":"城关镇","410328101":"王范回族镇","410328102":"上戈镇","410328103":"下峪镇","410328104":"河底镇","410328105":"兴华镇","410328106":"东宋镇","410328107":"马店镇","410328108":"故县镇","410328109":"赵村镇","410328110":"长水镇","410328111":"景阳镇","410328200":"城郊乡","410328205":"小界乡","410328209":"罗岭乡","410328213":"底张乡","410328216":"陈吴乡","410328217":"涧口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410328.json
// module id = 1671
// module chunks = 0